/* eslint-disable max-len */
import React from 'react';

const DropdownArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6">
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <g>
            <path
              d="M2.873 1.873L-1.127 5.367 -0.469 6.127 2.873 3.207 6.216 6.127 6.873 5.367z"
              transform="translate(-439.000000, -84.000000) translate(437.000000, 77.000000) translate(6.000000, 10.000000) rotate(-270.000000) translate(-6.000000, -10.000000) translate(3.500000, 6.000000) translate(2.873490, 4.000000) scale(1, -1) rotate(90.000000) translate(-2.873490, -4.000000)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default DropdownArrowIcon;
